
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class FabricStyleService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.fabric_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_FABRIC_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getFabricStylePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStylePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readFabricStyle(input, responseCallBack, errorCallBack) {
    this.method("readFabricStyle", input, responseCallBack, errorCallBack);
  }
  static readandLockFabricStyle(input, responseCallBack, errorCallBack) {
    this.method(
      "readandLockFabricStyle",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFabricStyleImage(input, responseCallBack, errorCallBack) {
    this.method(
      "createFabricStyleImage",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFabricStyle(input, responseCallBack, errorCallBack) {
    this.method("createFabricStyle", input, responseCallBack, errorCallBack);
  }
  static updateFabricStyle(input, responseCallBack, errorCallBack) {
    this.method("updateFabricStyle", input, responseCallBack, errorCallBack);
  }
  static unLockFabricStyle(input, responseCallBack, errorCallBack) {
    this.method("unLockFabricStyle", input, responseCallBack, errorCallBack);
  }
  static initFabricStyleModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initFabricStyleModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static convertBodyTextTojson(input, responseCallBack, errorCallBack) {
    this.method(
      "convertBodyTextTojson",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static convertStringJsonToObject(input, responseCallBack, errorCallBack) {
    this.method(
      "convertStringJsonToObject",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static fabricStyle_Image_Upload(input, responseCallBack, errorCallBack) {
    this.method(
      "fabricStyle_Image_Upload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getActiveFabricStylesForAutoComplete(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getActiveFabricStylesForAutoComplete",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static FabricStyleExcelUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "FabricStyleExcelUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readFabricStyleWithColors(input, responseCallBack, errorCallBack) {
    this.method(
      "readFabricStyleWithColors",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static webFabricDataInputExcelUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "webFabricDataInputExcelUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static checkRemovableFabricStyleColor(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "checkRemovableFabricStyleColor",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readFabricStyleForSoLine(input, responseCallBack, errorCallBack) {
    this.method(
      "readFabricStyleForSoLine",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStylePriceAndCost(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStylePriceAndCost",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readFabricStyleWithInventoryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readFabricStyleWithInventoryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readFabricStyleWithInventoryDetailsForSalesOrder(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readFabricStyleWithInventoryDetailsForSalesOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleWithCostMaintenanceInputFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleWithCostMaintenanceInputFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFabricStyleCostMaintenance(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createFabricStyleCostMaintenance",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockFabricStyleCostMaintenanceCode(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unLockFabricStyleCostMaintenanceCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initFabricStyleCostMaintenanceModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initFabricStyleCostMaintenanceModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleCostMaintenancePageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleCostMaintenancePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
    static createHoldingFabricInventoryDetail(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createHoldingFabricInventoryDetail",
      input,
      responseCallBack,
      errorCallBack
    );
  }


  static getHoldingFabricInventoryDetailPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getHoldingFabricInventoryDetailPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
    static getFabricStyleHoldingLotDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleHoldingLotDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  

    static getAllocatableRollLinesForHolding(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getAllocatableRollLinesForHolding",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static updateHoldingFabricInventoryDetail(input, responseCallBack, errorCallBack) {
    this.method("updateHoldingFabricInventoryDetail", input, responseCallBack, errorCallBack);
  }
  
  
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.fabric_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
       ServiceExecutorProxy.executeService(methodName, input,this.fabric_data_url,responseCallBack, errorCallBack);
    }
  }
}
